<template>
  <div id="profile">
    <div class="col_1_2 controls">
      <span style="font-weight: bold;" class="">Choose Geography Type: </span>
      <select class='comm_dropdown' v-on:change="$emit('set-geo-type', $event.target.value)">
        <option disabled value="">Choose a Geography Type</option>
        <option
          v-for="id in geotypesForMap"
          v-bind:key="id"
          v-bind:value="id"
          v-bind:selected="geotype===id"
        >{{ namesFromGeotype[id].name }}
        </option>
      </select>
      <span style="font-weight: bold;" v-if="geotype !== 'county'">Filter to:</span>
      <select class='comm_dropdown'
              v-if="geotype !== 'county'"
              v-on:change="setFilteredCounty($event.target.value)">
        <option disabled value="">Choose a Region to Focus on</option>
        <option
          v-bind:value="null"
          v-bind:selected="!filteredCounty"
        >All Counties Selected
        </option>
        <option
          v-for="id in countyIds"
          v-bind:key="id"
          v-bind:value="id"
          v-bind:selected="filteredCounty===id"
        >{{namesForCountyFilter.get(id)[0]}}
        </option>
      </select>
      <span style="font-weight: bold;">Selected {{namesFromGeotype[geotype].singularName}}:</span>
      <select class='comm_dropdown' v-on:change="setSelected(+$event.target.value)">
        <option disabled value="">Choose a Community</option>
        <option
          v-bind:value="8999"
          v-bind:selected="!selectedId"
        >Southeast Michigan
        </option>
        <option
          v-for="id in mcdIds"
          v-bind:key="id"
          v-bind:value="id"
          v-bind:selected="selectedId===id"
        >{{namesForSelectedType.get(id)[0]}}
        </option>
      </select>
    </div>
    <div id="charts" ref="charts">
      <div class="non-distribution"  v-bind:class="{'sticky': toggleSticky && !aboutPage, 'not_sticky': aboutPage || !toggleSticky}">
        <div class="col_1_2">
          <span style="font-size: 1em; display: inline-block;">
            <AboutMapPage
              v-on:aboutPage="aboutPage = $event"
              v-bind:inInerMode="inInerMode"
              v-bind:selectedId="selectedId"/>
          </span>
          <span style="margin-left: 10px;">
            <button type="button" class="share mapboxgl-ctrl-icon" title="Copy URL and Share" v-on:click="shareURL()"> Copy Url <font-awesome-icon
              icon='share-square'/></button>
          </span>
          <span style="margin-left: 10px" class="">
            <a v-if="geotype !== 'CensusTract'"
               v-bind:href="CPLink()"
               v-bind:title="'View ' + (selectedName || (filteredCounty && namesForCountyFilter.get(filteredCounty) && namesForCountyFilter.get(filteredCounty)[0]) || 'Southeast Michigan') + ' Community Profile Page' "
               style="white-space: nowrap;"><small>Link to: </small><img style="width: 18px;" src="images/region.svg" alt=""> Community Profile
            </a>
          </span>
        </div>
        <div>
          <div class="geoname">
            {{
              (selectedName || (filteredCounty && namesForCountyFilter.get(filteredCounty) && namesForCountyFilter.get(filteredCounty)[0]) || 'Southeast Michigan')
            }}</div>
          <div style="font-size: 1.2em; font-weight: bold" v-bind:style="{'color': selectedCompositeColor}"
              v-if="selectedTiles.length > 1">Composite Score: {{ formatDec(this.compositeScore) }} </div>
          <div style="margin: 5px; font-size: 1.1em;" v-if="tiles.length > 1 && project !== 'None'">Project: <br><strong>{{project}}</strong></div>
          <div style="margin: 5px; font-size: small;" v-if="tiles.length > 1 && project === 'None'"> <strong>Selected Demographic Datasets:</strong>
            <ul style="padding-left: 25px; margin: 5px; display: grid; grid-template-columns: 1fr 1fr; align-items: center;">
              <li style="margin-left: 12px;" v-for="t in getShortcutNamesForChart"
                  v-bind:key="t">{{ t }}
              </li>
            </ul>
          </div>
          <div style="font-size: small;" v-if="selectedTiles.length === 1 && project === 'None'"> <strong>Selected Dataset:</strong> {{this.getShortcutNamesForChart[0]}}</div>
        </div>

        <div>
          <radarChart v-bind:chartData="allScoresChart[0]"
                      v-bind:options="allScoresChart[1]"
                      v-if="selectedTiles.length > 1"
                      v-bind:class="'composite_chart'"/>
        </div>
        <div class="mapboxgl-ctrl-bottom-right" v-if="canCombine">
          <div class="mapboxgl-ctrl mapboxgl-ctrl-group">
            <font-awesome-icon v-on:click="saveCompositeFile()" title="Download Composite Data" style="padding: 1px; width: 20px; height: 20px" icon="file-download"/>
          </div>
        </div>
        <div class="mapboxgl-ctrl-bottom-left" v-if="selectedTiles.length > 1">
          <div class="mapboxgl-ctrl mapboxgl-ctrl-group">
            <font-awesome-icon v-on:click="toggleSticky = !toggleSticky" v-bind:title="(toggleSticky ? 'Unlock on page':'Lock on page')"
                               style="padding: 1px; width: 20px; height: 20px"
                               v-bind:icon="(toggleSticky ? 'lock':'unlock')"/>
          </div>
        </div>
      </div>
      <div
        class="distribution"
        v-for="gName in groupNames"
        v-bind:key="gName"
        v-bind:id="'group-'+gName"
      >
        <h2 class="col_1_2" v-if="groupDesc[gName]">
          <font-awesome-icon :icon='groupDesc[gName].iconName'/>
          {{groupDesc[gName].longName || (gName + ' Data')}} by {{namesFromGeotype[geotype].singularName}}
          <span class="info"
                v-if="groupDesc[gName].descExtra"
                v-tooltip="{
                        content: groupDesc[gName].descExtra,
                        classes: ['d3-tip'],
                        container: $refs.charts,
                        placement: 'bottom',
                      }"
          ></span>
        </h2>
        <div v-if="groupDesc[gName] && groupDesc[gName].desc" class="col_1_2"
           v-html="groupDesc[gName].desc">

        </div>
        <div class="col_1_2"
             style="display: grid;  grid-column-gap: 10px; grid-template-columns: auto 1fr 1fr; font-size: large;">
          <div style="grid-column: 1; grid-row: 1;" v-show="gName === 'Demographic' && canCombine" title="Select all the datasets">
            <button type="button" style="font-size: large;" v-on:click="selectAllTiles()">
              <font-awesome-icon style="padding: 1px;" icon="check-double"/>
            </button>
          </div>
          <div v-on:click="combineData()"
               style="grid-column: 2; grid-row: 1; border: 1px solid black; border-radius: 5px; "
               v-if="!nonScoreIndicators.includes(selectedTiles[0])" v-show="gName === 'Demographic'"><input type="checkbox"
                                                                                                        v-model="canCombine">
            Combine multiple
            datasets on the map.
          </div>
          <div style="grid-column: 3; grid-row: 1;" v-show="gName === 'Demographic' && canCombine">
            <button title="Download Composite Data" type="button" style="font-size: large;" v-on:click="saveCompositeFile()">
              <font-awesome-icon style="padding: 1px;" icon="file-download"/>
              Download Composite
            </button>
          </div>
        </div>
        <span class="col_1_2"  style="display: grid;  grid-column-gap: 10px; grid-template-columns: auto 1fr;">
          <span v-if="inInerMode" style="grid-column: 1; grid-row: 1; font-size: large; font-weight: bold" v-show="gName === 'Demographic'">Project Preset: </span>
          <select v-if="inInerMode" class="col_1_2 comm_dropdown project_dropdown"
                  v-show="gName === 'Demographic'" v-on:change="setTilesFromProject($event.target.value)">
            <option disabled value="">Choose a Project Set</option>
            <option
              v-for="id in Object.keys(projectDefinitions)"
              v-bind:key="id"
              v-bind:value="id"
              v-bind:selected="project===id"
            >{{ id }}
            </option>
          </select>
        </span>

        <GioDistributionChart
          v-for="shortcut in groups[gName]"
          v-bind="shortcut"
          v-bind:key="shortcut.name"
          v-bind:geogData="allNormalizedGeogData[shortcut.name]"
          v-bind:isSelectedShortcut="selectedShortcut && shortcut.name === selectedShortcut.name"
          v-bind:colorLegendData="selectedShortcut && shortcut.name === selectedShortcut.name && colorLegendData"
          v-bind:selectedId="selectedId"
          v-bind:getIndName="getIndName"
          v-bind:hoverId="hoverId"
          v-bind:aboutPageContent="aboutPageContent"
          v-bind:equityTooltips="equityTooltips"
          v-bind:selectedTiles="selectedTiles"
          v-bind:scoreColorLookup="scoreColorLookup"
          v-bind:nonScoreIndicators="nonScoreIndicators"
          v-bind:countyData="countyData"
          v-bind:regionData="regionData"
          hideWhenInvisible="true"
          v-bind:printing="printing"
          v-on:set-map="setMap($event)"
          v-on:set-sel-geom-id="setSelected($event)"
          v-on:set-hov-geom-id="setHover($event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import GioDistributionChart from './charts/GioDistributionChart.vue'
import radarChart from './charts/radarChart.vue'
import AboutMapPage from './AboutMapPage.vue'
import * as d3 from 'd3'
import {saveAs} from 'file-saver';

export default {
  name: 'Profile',
  components: { GioDistributionChart, radarChart, AboutMapPage},
  props: [
    'shortcuts',
    'groupNames',
    'groups',
    'groupDesc',
    'projectDefinitions',
    'project',
    'aboutPageContent',
    'equityTooltips',
    'tiles',
    'nonScoreIndicators',
    'selectedShortcut',
    'colorLegendData',
    'incomeChartIndicators',
    'incomeChartCutoffs',
    'ageDataMaleChartIndicators',
    'ageDataFemaleChartIndicators',
    'selectedId',
    'selectedCompositeColor',
    'selectedName',
    'filteredCounty',
    'namesForSelectedType',
    'namesForCountyFilter',
    'geotypesForMap',
    'hoverId',
    'allGeogData',
    'countyData',
    'regionData',
    'getIndName',
    'getIndYear',
    'getIndMoeName',
    'namesFromGeotype',
    'geotype',
    'inInerMode',
    'scoreColorLookup',
    'printing',
  ],
  data: function (){
    return {
      selectedTiles: this.tiles,
      canCombine: this.tiles.length > 1,
      compositeScore: 0,
      allSelected: false,
      toggleSticky: true,
      aboutPage: true,
    }
  },
  methods: {
    setMap: function (id) {
      if (!this.selectedTiles.includes(id[0]) && this.canCombine && !this.nonScoreIndicators.includes(id[0])) {
        this.selectedTiles.push(id[0])
      } else if (this.selectedTiles.includes(id[0]) && this.selectedTiles.length > 1) {
        this.selectedTiles = this.selectedTiles.filter(e => e !== id[0])
      } else {
        this.canCombine = false
        this.selectedTiles = [id[0]]
      }
      this.$emit('project', 'None')
      this.$emit('tiles', this.selectedTiles)
    },
    setFilteredCounty: function (id) {
      this.$emit('set-filtered-county', id)
    },
    setTilesFromProject: function (id){
      this.canCombine = true
      this.allSelected = false
      this.$emit('project', id)
    },
    countyIdLookup: function (id) {
      let ids = {
        93: 'https://data.semcog.org/community-profiles?mcd=7005,7010,7015,7020,7025,7027,7030,7035,7040,7045,7050,7055,7060,7065,7070,7075,7080,7085,7090,7095,7100&counties=93',
        99: 'https://data.semcog.org/community-profiles?mcd=3005,3010,3015,3020,3025,3030,3035,3040,3045,3050,3055,3060,3065,3070,3075,3080,3085,3090,3095,3100,3105,3110,3115,3120,3125,3130,3135&counties=99',
        115: 'https://data.semcog.org/community-profiles?mcd=5005,5010,5015,5020,5025,5030,5035,5040,5045,5047,5050,5055,5060,5065,5070,5075,5080,5085,5090,5095,5100,5105,5110,5115,5120&counties=115',
        125: 'https://data.semcog.org/community-profiles?mcd=2005,2010,2015,2020,2025,2030,2035,2040,2045,2050,2055,2060,2065,2072,2073,2075,2080,2085,2090,2095,2100,2105,2110,2115,2120,2125,2130,2135,2140,2145,2150,2155,2160,2165,2170,2172,2175,2180,2185,2190,2195,2200,2205,2210,2215,2220,2230,2235,2240,2245,2250,2252,2255,2260,2265,2270,2275,2280,2285,2290,2295,2300&counties=125',
        147: 'https://data.semcog.org/community-profiles?mcd=6005,6010,6015,6020,6025,6030,6035,6040,6045,6050,6055,6060,6065,6070,6075,6080,6085,6090,6095,6100,6105,6110,6115,6120,6125,6135,6140,6142,6145,6150,6155,6160,6165&counties=147',
        161: 'https://data.semcog.org/community-profiles?mcd=4005,4010,4015,4018,4020,4025,4030,4035,4040,4045,4050,4055,4060,4065,4070,4075,4080,4085,4090,4095,4100,4105,4110,4115,4120,4125,4130,4135&counties=161',
        163: 'https://data.semcog.org/community-profiles?mcd=5,1005,1010,1015,1020,1025,1030,1040,1045,1050,1055,1060,1065,1070,1075,1080,1085,1090,1095,1100,1105,1110,1115,1120,1125,1130,1135,1140,1145,1150,1155,1160,1165,1170,1175,1180,1185,1190,1200,1205,1210,1215,1220&counties=163',
      }
      return ids[id] || id || 8999
    },
    zoomTo: function (gName) {
      document.getElementById(gName).scrollIntoView()
    },
    setSelected: function (id) {
      this.$emit('set-sel-geom-id', id)
    },
    selectAllTiles: function (){
      this.selectedTiles = ['popage65andup_24','popage0_17_24','popminority_24','popinpoverty_24','hh_transitdependent_24','blacknonhisp_24','asiannonhisp_24', 'householdsinpoverty_24', 'hispanic_24','popother_24','popage16_19_noschoolorwork_24','popdisability_24','popforeignborn_24','hh_limitedenglish_24','hh_nocar_24','femalenospousehh_24','hh_housingcostburden_24','unemploymentrate_24']
      this.allSelected = true
      this.$emit('project', 'None')
      this.$emit('tiles', this.selectedTiles)
    },
    combineData: function (){
      this.canCombine = !this.canCombine
    },
    setHover: function (id) {
      this.$emit('set-hov-geom-id', id)
    },
    CPLink: function () {
      if (this.selectedId && this.geotype !== 'CensusTract') {
        return 'https://data.semcog.org/community-profiles?mcd=' + this.selectedId
      } else if (this.filteredCounty) {
        return this.countyIdLookup(this.filteredCounty)
      } else {
        return 'https://data.semcog.org/community-profiles'
      }
    },
    shareURL: function () {
      let textarea = document.createElement('textarea');
      textarea.textContent = window.location.href;
      textarea.style.position = 'fixed';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy')
    },
    saveCompositeFile: function () {
      // eslint-disable-next-line no-undef
      ga('send', 'event', 'DownloadCompositeCSV', (this.project === 'None' ? 'Composite' : this.project), 'Demographic Emphasis Areas')
      // eslint-disable-next-line no-undef
      gtag('event', "DownloadCompositeCSV", {'change': (this.project === 'None' ? 'Composite' : this.project), 'map_name': 'Demographic Emphasis Areas'})
      let columns = ['Id', 'Name']
      this.selectedTiles.forEach(t => columns.push('Score ' + this.getIndName(t), this.getIndName(t), 'Percent ' + this.getIndName(t)))
      columns.push('Composite Score')
      let blob = new Blob([
        columns.join(',') + '\n',
        this.allGeogData_sorted.map(g => {
          let base = [g.geoid, g.name]
          let sum = 0
          this.selectedTiles.forEach(t => sum += g['score_' + t])
          this.selectedTiles.forEach(t => base.push(g['score_' + t], g[t], g['pct_' + t]))
          base.push(this.formatDec(sum / this.selectedTiles.length))
          return base.join(',')
        }).join('\n'),
      ], {type: 'text/plain;charset=utf-8'})
      saveAs(blob, 'SEMCOG DemographicData '+ (this.project === 'None' ? 'Composite' : this.project) +' Data 2020-2024 ACS_Data.csv')
    },
    format: d3.format(',d'),
    formatPct: d3.format('0.0%'),
    formatDec: d3.format('.2f'),
  },
  computed: {
    mcdIds: function () {
      return Array.from(this.namesForSelectedType.keys()).sort(
        (aId, bId) => {
          let a = this.namesForSelectedType.get(aId)[0]
          let b = this.namesForSelectedType.get(bId)[0]
          return a.localeCompare(b)
        })
    },
    countyIds: function () {
      return Array.from(this.namesForCountyFilter.keys()).sort(
        (aId, bId) => {
          let a = this.namesForCountyFilter.get(aId)[0]
          let b = this.namesForCountyFilter.get(bId)[0]
          return a.localeCompare(b)
        })
    },
    allGeogData_sorted: function () {
      function compare(a, b) {
        const A = a.geoid;
        const B = b.geoid;
        let comparison = 0;
        if (A > B) {
          comparison = 1;
        } else if (A < B) {
          comparison = -1;
        }
        return comparison;
      }

      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.allGeogData.sort(compare)
    },
    allNormalizedGeogData: function () {
      let chartData = {}
      this.shortcuts.forEach(i => {
        chartData[i.name] = this.allGeogData
          // .filter(val => val[i.denominator])
          // .filter(val => val[i.denominator] > (val[this.getIndMoeName(i.denominator)] || 0))
          // .filter(val => val[i.numerator]) //TODO:Do we need these filters?
          .map(val => {
            let denom = val[i.denominator]
            let denomMoe = val[this.getIndMoeName(i.denominator)] || 0
            let noom = val[i.numerator]
            let noomMoe = val[this.getIndMoeName(i.numerator)] || 0
            let value = noom / denom
            let score = val['score_' + i.numerator]

            if (i.numerator === 'disadvantagedcommunity') {
              value = 'Disadvantaged'
              if (val[i.numerator] === 0) {
                value = 'Not Disadvantaged'
              }
            } else if (i.numerator === 'raise') {
              value = 'APP'
              if (val[i.numerator] === 0) {
                value = 'Not APP'
              }
            } else if (i.numerator === 'dac_cvr') {
              value = 'Disadvantaged'
              if (val[i.numerator] === 0) {
                value = 'Not Disadvantaged'
              }
            }

            // MOE of X/Y =1/Y * SQRT ((XMOE)2- ((X/Y)2*(YMOE)2))
            let a = Math.pow(noomMoe, 2)
            let b = Math.pow(value * denomMoe, 2)
            let moe
            if (a > b && i.properFraction) {
              moe = Math.sqrt(a - b) / denom
            } else {
              moe = Math.sqrt(a + b) / denom
            }

            let maxMoe
            if (i.properFraction) {
              maxMoe = 1
            } else {
              maxMoe = 2 * value
            }

            return {
              name: val.name.trim(),
              geoid: val.geoid,
              value: [
                Math.max(value - moe, 0),
                value,
                Math.min(value + moe, maxMoe),
              ],
              numerator: noom,
              score: score,
            }
          })
      })
      this.shortcuts.forEach(i => chartData[i.name].sort((a, b) => b.value[1] - a.value[1]))

      return chartData
    },
    incomeData: function () {
      return this.incomeChartIndicators.map(ind => {
        let value = this.totalInd[ind] || 0
        let moe = this.totalInd[this.getIndMoeName(ind)] || 0
        return {
          name: ind,
          value: value,
          moe: moe,
        }
      })
    },
    ageDataMale: function () {
      return this.ageDataMaleChartIndicators.map(ind => {
        let value = this.totalInd[ind] || 0
        let moe = this.totalInd[this.getIndMoeName(ind)] || 0
        return {
          name: ind,
          value: value,
          moe: moe,
        }
      })
    },
    ageDataFemale: function () {
      return this.ageDataFemaleChartIndicators.map(ind => {
        let value = this.totalInd[ind] || 0
        let moe = this.totalInd[this.getIndMoeName(ind)] || 0
        return {
          name: ind,
          value: value,
          moe: moe,
        }
      })
    },
    getShortcutNamesForChart: function () {
      let names = []
      this.selectedTiles.map((t) => {
        this.shortcuts.forEach((s) => {
          if (s.numerator === t) {
            names.push(s.name)
          }
        })
      })
      return names
    },
    allScoresChart: function () {
      return [{
        labels: this.getShortcutNamesForChart,
        datasets: [
          {
            label: 'Selected Datasets',
            backgroundColor: 'rgba(152,161,239,0.2)',
            borderColor: 'black',
            borderWidth: 2,
            tension: 0.1,
            fill: true,
            data: this.selectedTiles.map(t => this.totalInd['score_' + t]),
            order: 2,
          },
          {
            label: 'Composite',
            borderColor: 'grey',
            backgroundColor: 'rgba(104,104,104,0.1)',
            borderDash: [5, 2],
            borderWidth: 1,
            fill: true,
            data: this.selectedTiles.map(() => this.formatDec(this.compositeScore)),
        },
        ],
      }, {
        title: {
          text: 'Composite Score',
          fontSize: 18,
          fontColor: 'black',
          position: 'top',
          display: false,
        },
        legend: {
          display: true,
        },
        elements: {
          point: {
            radius: 4,
          },
        },
        tooltips: {
          callbacks: {
            label: (tooltipItem, data) => {
              let label = ''
              if (tooltipItem.datasetIndex === 0) {
                this.shortcuts.forEach((s) => {
                  if (s.name === data.labels[tooltipItem.index]) {
                    if (s.numerator === 'hhmedinc_24') {
                      label = data.labels[tooltipItem.index] + ": $" + this.format(this.totalInd[s.numerator])
                    } else if (s.numerator === 'unemploymentrate_24') {
                      label = data.labels[tooltipItem.index] + ": " + this.formatPct(this.totalInd[s.numerator])
                    } else {
                      label = data.labels[tooltipItem.index] + ": " + this.formatPct(this.totalInd["pct_" + s.numerator])
                    }
                  }
                })
              }
              return label;
            },
          },
        },
        plugins: {
          datalabels: {
            color: 'black',
            backgroundColor: (context) => {
              if (context.datasetIndex === 0 && this.scoreColorLookup[context.dataset.data[context.dataIndex]])
                return this.scoreColorLookup[context.dataset.data[context.dataIndex]].color;
            },
            opacity: 0.9,
            textShadowBlur: 6,
            textShadowColor: 'white',
            borderRadius: 4,
            padding: 5,
            font: (context) => {
              var width = context.chart.width;
              var size = Math.round(width / 38);

              return {
                weight: 'bold',
                size: size,
              };
            },
            formatter: (value, context) => {
              if (context.datasetIndex === 0) {
                return value
              } else {
                return ''
              }

            },
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        scale: {
          ticks: {
            min: 0,
            max: 4,
          },
        },
      }]
    },
    totalInd: function () {
      if (!this.selectedId && !this.regionData) {
        return {}
      }
      let sel = (this.selectedId && this.allGeogData.find(geo => geo.geoid === this.selectedId))
      if (sel) {
        return sel
      }
      if (this.filteredCounty) {
        return this.countyData
      }
      return this.regionData
    },
  },
  watch: {
    canCombine: function (){
      if (!this.canCombine) {
        this.selectedTiles = [this.selectedTiles[this.selectedTiles.length - 1]]
        this.allSelected = !this.allSelected
        this.$emit('tiles', this.selectedTiles)
        this.$emit('project', 'None')
      } else {
        this.selectedTiles = this.selectedTiles.filter( (val, index)  => val !== this.nonScoreIndicators[index])
      }
    },
    tiles: function (){
      this.selectedTiles = this.tiles
    },
    selectedTiles: {
      immediate: false,
      handler: function () {
        this.compositeScore = 0
        this.selectedTiles.forEach(t => this.compositeScore += this.totalInd['score_' + t])
        this.compositeScore = this.compositeScore/this.selectedTiles.length
        if (this.selectedTiles.length > 1) {
          this.$emit('composite-score', this.compositeScore)
        }
      },
    },
    totalInd: {
      immediate: false,
      handler: function () {
        this.compositeScore = 0
        this.selectedTiles.forEach(t => this.compositeScore += this.totalInd['score_' + t])
        this.compositeScore = this.compositeScore/this.selectedTiles.length
        if (this.selectedTiles.length > 1){
          this.$emit('composite-score', this.compositeScore)
        }
      },
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #profile {
    grid-column: 2;
    grid-row: 2;
    background: #fefefe;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: max-content auto;
    min-height: 0;
  }

  #charts {
    overflow-y: auto;
    background: #fefefe;
    position: relative;
  }

  #charts > div {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 5px;
    row-gap: 5px;
    margin: 10px;
    padding: 7px;
    box-shadow:  -12px 12px 20px -5px #cbc7c7;;
    background: white;
    border-radius: 5px;
    border-color: #cbc7c7;
    border-width: 1px;
    border-style: solid;
  }

  .non-distribution {
    grid-template-columns: 40% 60% !important;
    display: grid !important;
    z-index: 1;
    top: 0;
    background: white;
  }

  .sticky {
    position: sticky;
  }

  .not_sticky {
    position: relative;
  }

  @media (max-width: 576px) {
    .non-distribution {
      display: block !important;
    }
  }

  h2, h3, h4, h5 {
    margin: 0;
  }

  div a {
    font-size: medium;
    color: #0f2d53;
    font-weight: bold;
    vertical-align: middle;
  }

  .controls {
    display: grid;
    grid-template-columns: 25% max-content 1fr max-content;
    grid-template-rows: 1fr 1fr;
    grid-column-gap: 5px;
    padding: 4px;
    background-color: #eef7f5;
  }

  .col_1_2 {
    grid-column-start: 1;
    grid-column-end: 3;
  }
  .col_1 {
    grid-column-start: 1;
    grid-column-end: 1;
  }
  .geoname{
    font-size: 1.5em;
    font-weight: bold;
  }

  .share {
    background: rgba(107, 153, 91, 0.7);
    border-radius: 4px;
    border-width: 1px;
    border-color: #9aa5a9;
    margin-left: 5px;
  }

  .share:hover {
    background: #9aa5a9;
  }

  .info {
    content: '';
    cursor: pointer;
    position: absolute;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill='%23333333' fill-rule='evenodd' d='M4,10a6,6 0 1,0 12,0a6,6 0 1,0 -12,0 M9,7a1,1 0 1,0 2,0a1,1 0 1,0 -2,0 M9,10a1,1 0 1,1 2,0l0,3a1,1 0 1,1 -2,0'/%3E %3C/svg%3E");
    background-color: rgba(255, 255, 255, 0.5);
    width: 24px;
    height: 24px;
    box-sizing: border-box;
    border-radius: 12px;
  }

  /deep/ .mapboxgl-ctrl-bottom-right .mapboxgl-ctrl-bottom-left {
    z-index: 1 !important;
  }

  /deep/ .my-tooltip {
    display: block !important;
    z-index: 1;
    font-size: small;
    max-width: 90%;
  }

  /deep/ .my-tooltip strong {
    font-size: medium;
  }

  /deep/ .my-tooltip small {
    color: #9aa5a9;
    font-size: small;
  }

  /deep/ .my-tooltip .my-tooltip-inner {
    background: #292424;
    color: white;
    opacity: 0.95;
    border-radius: 16px;
    padding: 5px 10px 4px;
  }

  /deep/ .my-tooltip .my-tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: #292424;
    opacity: 0.95;
    z-index: 1;
  }

  /deep/ .my-tooltip[x-placement^="top"] {
    margin-bottom: 10px;
  }

  /deep/ .my-tooltip[x-placement^="top"] .my-tooltip-arrow {
    border-width: 5px 5px 0 5px;
    border-left-color: transparent !important;
    border-right-color: transparent !important;
    border-bottom-color: transparent !important;
    bottom: -5px;
    left: calc(50% - 10px);
    margin-top: 0;
    margin-bottom: 0;
  }

  /deep/ .my-tooltip[x-placement^="bottom"] {
    margin-top: 10px;
  }

  /deep/ .my-tooltip[x-placement^="bottom"] .my-tooltip-arrow {
    border-width: 0 5px 5px 5px;
    border-left-color: transparent !important;
    border-right-color: transparent !important;
    border-top-color: transparent !important;
    top: -5px;
    left: calc(50% - 10px);
    margin-top: 0;
    margin-bottom: 0;
  }

  /deep/ .my-tooltip[x-placement^="right"] {
    margin-left: 10px;
  }

  /deep/ .my-tooltip[x-placement^="right"] .my-tooltip-arrow {
    border-width: 5px 5px 5px 0;
    border-left-color: transparent !important;
    border-top-color: transparent !important;
    border-bottom-color: transparent !important;
    left: -5px;
    top: calc(50% - 5px);
    margin-left: 0;
    margin-right: 0;
  }

  /deep/ .my-tooltip[x-placement^="left"] {
    margin-right: 10px;
  }

  /deep/ .my-tooltip[x-placement^="left"] .my-tooltip-arrow {
    border-width: 5px 0 5px 5px;
    border-top-color: transparent !important;
    border-right-color: transparent !important;
    border-bottom-color: transparent !important;
    right: -5px;
    top: calc(50% - 5px);
    margin-left: 0;
    margin-right: 0;
  }

  /deep/ .my-tooltip.popover .popover-inner {
    background: #f9f9f9;
    color: #292424;
    padding: 24px;
    border-radius: 5px;
    box-shadow: 0 5px 30px rgba(0, 0, 0, .1);
  }

  /deep/ .my-tooltip.popover .popover-arrow {
    border-color: #f9f9f9;
  }

  /deep/ .my-tooltip[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity .15s, visibility .15s;
  }

  /deep/ .my-tooltip[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity .15s;
  }

  .single-ind {
    text-align: center;
  }

  .comm_dropdown {
    border-color: #f5f5f5;
    border-radius: 10px;
    max-width: 100%;
    font-size: 1em;
    margin-left: 3px;
    border: 1px solid;
  }

  .comm_dropdown:focus {
    outline: 2px;
    border-color: black;
  }

  .comm_dropdown option {
    font-size: 0.8rem;
  }

  .project_dropdown {
    grid-column: 2;
    grid-row: 1;
    font-size: 1.2em;
    width: max-content;
  }

  .composite_chart {
    width: 98%;
    height: 27vh;
    grid-column-start: 1;
    grid-column-end: 4;
    padding: 10px;
  }

  /deep/ .mapboxgl-ctrl-group > button {
    width: 29px;
    height: 29px;
  }

  @media (max-width: 576px), print {
    #charts {
      overflow-y: unset;
    }

    #profile {
      grid-column: 1;
      grid-row: 3;
      overflow-y: unset;
    }

    .distribution {
      page-break-before: always;
    }

    .controls {
      display: block;
      font-size: 1em;
    }
    .project_dropdown{
      width: unset;
    }
  }

  @media (max-width: 1400px) {
    .controls {
      grid-template-columns: auto auto auto auto;
      font-size: .8em;
    }
  }

  @media (max-width: 970px) {
    .comm_dropdown {
      width: 100%;
    }
  }
</style>
